// Legacy (V2) parity: horizontal hover card — image flush on the LEFT with
// rounded left corners, title on the right. Mirrors the legacy
// `components/map/map.tsx` popup: `min-w-[260px] flex-row gap-3`,
// image `max-w-[120px]` rounded-left, body `py-3 pr-3 pl-0`, title
// `text-sm leading-[1.2] font-semibold`. The hosting `.products-map-tip`
// strips the tooltip padding + clips to a 10px radius so the image sits
// flush in the corner.
.root {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  gap: 12px;
  min-height: 88px;
  min-width: 260px;
}

.image,
.image-placeholder {
  background: var(--color-secondary);
  border-radius: 10px 0 0 10px;
  flex: 0 0 120px;
  object-fit: cover;
  width: 120px;
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  min-width: 0;
  padding: 12px 12px 12px 0;
}

.title {
  color: var(--color-foreground);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}
